module.exports = __webpack_public_path__ + "static/media/no-img.a77a9fc1.png";